import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';

const ProductArraySkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="overflow-hidden overflow-x-auto my-2.5 mx-auto" ref={viewRef}>
      <div className="flex justify-between mb-2 pl-3" style={{ flexFlow: 'column nowrap' }}>
        <div className="bg-surface-200-bg inline-block w-16 h-5 leading-8 rounded-sm skeleton mb-2" />
        <div className="bg-surface-200-bg inline-block w-16 h-6 leading-8  rounded-sm skeleton" />
      </div>
      <div className="max-w-full overflow-hidden">
        <div className="box-border flex w-[477px] pl-3 pr-0.5 py-0" style={{ flexFlow: 'row wrap' }}>
          {new Array(6).fill(0).map((_item, index) => {
            return <ProductCardSkeleton className="mr-3" key={`product-array-skeleton-${index}`} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductArraySkeleton;
